const paymentPaths = {
  merchantAccounts: '/payment/merchant-accounts',
  corporations: '/payment/corporations',
  banks: '/payment/banks',
  pools: '/payment/pools',
  newPool: '/payment/pools/new',
  editPool: (id = ':id') => `/payment/pools/${id}/edit`,
  rebillPools: '/payment/rebill-pools',
  newRebillPool: '/payment/rebill-pools/new',
  editRebillPool: (id = ':id') => `/payment/rebill-pools/${id}/edit`,
  binRoutings: '/payment/bin-routings',
  cardBins: '/payment/bin-routings/card-bins',
  badBins: '/payment/bin-routings/bad-bins',
  newBinRoutings: '/payment/bin-routings/new',
  editBinRoutings: (id = ':id') => `/payment/bin-routings/${id}/edit`,
  settings: '/payment/reprocessing',
  retries: '/payment/reprocessing/programs',
  reprocflowMapping: '/payment/reprocessing/initials',
  rebillflowMapping: '/payment/reprocessing/subscriptions',
  upsell: '/payment/reprocessing/upsells',
  merchantProfiles: '/payment/payment-routing',
  newMerchantProfile: '/payment/payment-routing/new',
  editMerchantProfile: (id = ':id') => `/payment/payment-routing/${id}/edit`,
};

export default paymentPaths;
